import React, { Component} from 'react';
import moment from 'moment';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import MoreVertIcon from 'material-ui-icons/MoreVert';

class SponsorItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  render() {
    const { sponsor } = this.props;
    const is_checked = _.includes(this.props.sponsor_ids, sponsor.id);
    const ITEM_HEIGHT = 48;
    const { anchorEl } = this.state;
    return (
      <tr>
        <td>
          { !(new Date(sponsor.start_date) <= new Date() && new Date(sponsor.end_date) >= new Date()) &&
            <p>
              <input
                type="checkbox"
                className="filled-in"
                id="filled-in-box10"
                checked={is_checked}
                key={sponsor.id}
              />
              <label for="filled-in-box10" onClick={() => this.props.checkedSponsorIds(sponsor.id)}></label>
            </p>
            }
        </td>
        {/* <td>{moment(sponsor.start_date).format('D/M/YYYY')}
          <span>{moment(sponsor.start_date).format('h:mm a').toUpperCase()}</span>
        </td> */}
        <td>{sponsor.title || 'N/A'}</td>
        <td>{sponsor.namespace}</td>
        <td>
          <IconButton
            className="table_more"
            aria-label="More"
            aria-owns={anchorEl ? 'long-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: 200
              }
            }}
          >

            <MenuItem onClick={() => this.props.navigateToSponsor(sponsor.id)}>
                Edit
            </MenuItem>
          </Menu>
        </td>
      </tr>

    );
  }
}

SponsorItem.defaultProps = {};

SponsorItem.propTypes = {};

export default SponsorItem;



// WEBPACK FOOTER //
// ./src/components/Admin/Sponsor/List/SponsorItem.jsx